import React from "react";

import {
  Box,
  BoxPanel,
  PieChart,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  TruncateTooltip,
  CircularProgress,
} from "@tiny/components";
import { useSubscribersBySourceStats } from "./SubscribersBySourceStats.hooks";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import { formatNumber } from "@tiny/components/src/utils/formatUtils";

function SubscribersBySourceStats() {
  const { chartData, isLoading } = useSubscribersBySourceStats();
  const { mdUp } = useBreakpoints();

  return (
    <BoxPanel title="Sources" contentWithPadding headerNoBorder={!mdUp}>
      {isLoading ? (
        <Box
          width="100%"
          height="220px"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box display="flex" flexDirection={{ xs: "column", md: "row" }}>
          <Box flex="1" order={{ xs: 2, md: 1 }}>
            <Table size="small" sidePadding={0} layoutFixed hideLastRowBorder>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography variant="label3" color="grey" tone={700}>
                      Source
                    </Typography>
                  </TableCell>
                  <TableCell align="right" width="80px">
                    <Typography variant="label3" color="grey" tone={700}>
                      Total
                    </Typography>
                  </TableCell>
                  <TableCell align="right" width="92px">
                    <Typography variant="label3" color="grey" tone={700}>
                      Percent
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {chartData.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>
                      <TruncateTooltip>
                        <Typography
                          variant="body2"
                          color="grey"
                          tone={900}
                          noWrap
                          display="block"
                          my={1}
                          bullet
                          bulletColor={item.color}
                        >
                          {item.label}
                        </Typography>
                      </TruncateTooltip>
                    </TableCell>
                    <TableCell align="right">
                      <Typography
                        variant="body2"
                        color="grey"
                        tone={900}
                        fontWeight="bold"
                      >
                        {formatNumber(item.value)}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography
                        variant="body2"
                        color="grey"
                        tone={900}
                        fontWeight="bold"
                      >
                        {item.percent}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
          <Box
            flex="0 0 178px"
            display="flex"
            justifyContent={{ xs: "center", md: "flex-end" }}
            alignItems="center"
            order={{ xs: 1, md: 2 }}
          >
            <PieChart
              width={150}
              data={chartData}
              valueAccessor={(item) => item.value}
              colorAccessor={(item) => item.color}
            />
          </Box>
        </Box>
      )}
    </BoxPanel>
  );
}

export default SubscribersBySourceStats;
